export enum MessageBoxIcon {
    None = 0,
    Information = 1,
    Warning = 2,
    Question = 3,
    Error = 4
}